import Home from "./pages/Home";

export default function App() {
  return (<Home />);
}
// export default function App() {
//   return <h1 style={{ color: "lime" }}>React is working</h1>;
// }
